export const types = {
  SET_EDITOR: 'SET_EDITOR',
  SET_RAPIDEDITOR: 'SET_RAPIDEDITOR',
};
